import { render, staticRenderFns } from "./filesModel.vue?vue&type=template&id=721f2a14"
import script from "./filesModel.vue?vue&type=script&lang=js"
export * from "./filesModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('721f2a14')) {
      api.createRecord('721f2a14', component.options)
    } else {
      api.reload('721f2a14', component.options)
    }
    module.hot.accept("./filesModel.vue?vue&type=template&id=721f2a14", function () {
      api.rerender('721f2a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/filesManage/filesModel.vue"
export default component.exports